import { api } from "../http/axiosClient";
import { setAccessToken, setRefreshToken, getRefreshToken, clearTokens } from "./tokenStorage";

export async function login(email, password) {
  const body = new URLSearchParams();
  body.append("grant_type", "password");
  body.append("username", email);     
  body.append("password", password);
  
  const res = await api.post("/auth/login", body, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  setAccessToken(res.data.access_token ?? res.data.accessToken);
  if (res.data.refresh_token ?? res.data.refreshToken) {
    setRefreshToken(res.data.refresh_token ?? res.data.refreshToken);
  }

  return res.data;
}

export async function refresh() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token");

  const res = await api.post("/auth/refresh", { refreshToken });

  setAccessToken(res.data.accessToken);
  if (res.data.refreshToken) setRefreshToken(res.data.refreshToken);

  return res.data.accessToken;
}

export function logout() {
  clearTokens();
  window.location.assign("/");
}
